<template>
  <div class="col-12">
    <b-row>
      <b-col cols="12">
        <b-card>
          <div slot="header">
            {{ $lang.One_source_access_for_all_roles }}
          </div>

          <b-row>
            <b-col cols="12" md="12">
              <b-form-group
                :label="$lang.role_resource"
                label-for="role_selected"
                :label-cols="$config.form.labelCol"
              >
                <requiredComponent
                  slot="label"
                  :label="$lang.role_resource"
                  :rules="$v.role_selected.$params"
                />
                <selectFind
                  :options="role_system_options"
                  v-model="$v.role_selected.$model"
                  label="text"
                  :isValid="
                    $v.role_selected.$dirty ? !$v.role_selected.$error : null
                  "
                  :loading="roleLoading"
                  @input="fetchData"
                />

                <b-form-invalid-feedback
                  id="role_selected-feedback"
                  :style="{
                    display: $v.role_selected.$error ? 'block' : 'none',
                  }"
                >
                  {{
                    $lang.error_required | replace($lang.role_resource)
                  }}</b-form-invalid-feedback
                >
              </b-form-group>
            </b-col>
            <b-col cols="12" md="12">
              <LoadingSpinner :loading="loadingItem" />
            </b-col>

            <b-col v-if="!loadingItem && items.length" cols="12" md="12">
              <b-alert :show="!loadingItem" variant="info">
                <mdicon name="help-circle-outline" size="20" />
                <strong v-text="alertText" class="ml-1" />
              </b-alert>
              <TableRole :items="items" :fields="fields" @fetchData="fetchData" />
            </b-col>
          </b-row>
          <div
            v-if="!loadingItem && items.length > 0"
            slot="footer"
            class="form-group form-btn"
          >
            <!-- This button is temporarily hidden -->
            <b-button
              v-if="false"
              type="button"
              @click="save"
              size="md"
              variant="success"
            >
              {{ $lang.submitButton }}
              <i class="fa fa-check"></i>
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import TableRole from "./tableRole";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { required } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { generateApiUrl } from "@/shared/utils";

export default {
  name: "access-for-all-roles",
  components: {
    TableRole,
    LoadingSpinner,
  },
  validations: {
    role_selected: {},
  },
  data() {
    return {
      role_system_options: [],
      role_selected: {},
      loadingItem: false,
      items: [],
      roleLoading: false,
      fields: ["نقش", "خواندنی", "ویرایش", "کامل"],
    };
  },
  computed: {
    alertText() {
      return "نمایش دسترسی هر منبع بر اساس دسترسی پدرش می باشد نه دسترسی کاربر جاری لذا برای تغییر نقش منبع فرزند ابتدا نقش پدر تغییر داده شود بعد از ذخیره و نمایش مجدد نقش فرزند تغییر کند";
    },
  },
  methods: {
    pathOr,
    generateApiUrl,
    async getPermissionGroups() {
      try {
        const url = generateApiUrl(["metaData", "permission_group"]);
        const response = await this.$httpService.get(url);
        const data = pathOr([], ["data", "data"], response);

        let chosses = [
          {
            value: this.$lang.chosses,
            text: this.$lang.chosses,
          },
        ];
        let items = data.map((x) => {
          return {
            text: x.caption,
            value: x.name,
          };
        });
        this.role_system_options = [...chosses, ...items];
        this.role_selected = this.role_system_options.find((x, i) => i == 0);
      } catch (error) {
        this.$generateError(error);
      }
    },
    async fetchData() {
      let selected = this.role_selected && this.role_selected.value;
      if (selected !== this.$lang.chosses) {
        try {
          this.loadingItem = true;
          const url = generateApiUrl(
            ["resources", "resource_role_permission"],
            [selected]
          );
          const response = await this.$httpService.get(url);
          const data = pathOr([], ["data", "data"], response);
          this.items = data.map((x, index) => {
            const parent_acl_role_all = [
              {
                text: "محدود",
                value: "self",
                tooltip: x.acl_self_description,
              },
              {
                text: "همه",
                value: "all",
                tooltip: x.acl_all_description,
              },
            ];
            const parent_acl_role_self = [
              {
                text: "محدود",
                value: "self",
                tooltip: x.acl_self_description,
              },
            ];
            return {
              id: index + 1,
              name: x.role && x.role.caption,
              parent_acl_role: x.parent_acl_role,
              // به دلیل این که می خواستیم دیتا اول خواندنی تا کامل باشد این گونه شد
              permissions: x.permissions.reverse(),
              acl_role_options:
                x.parent_acl_role === "all"
                  ? parent_acl_role_all
                  : parent_acl_role_self,
              acl_role: pathOr(null, ["0", "acl_role"], x.permissions),
              role: x.role,
            };
          });
        } catch (error) {
          this.$generateError(error);
        } finally {
          this.loadingItem = false;
        }
      } else {
        this.items = [];
      }
    },
    async save() {
      try {
        this.loadingItem = true;
        let permissions = [];
        let data = this.items;

        data.filter((x) => {
          let item = x.permissions.find((x) => x.assigned == true);
          if (item !== undefined) {
            permissions.push({
              permission_id: pathOr(null, ['id'], item),
              acl_role: x.acl_role,
              role_code: x.role && x.role.code,
            });
          }
        });
        const selected = pathOr(null, ["value"], this.role_selected);
        const url = generateApiUrl(
          ["resources", "resource_role_permission"],
          [selected]
        );
        const payload = { permissions };
        const response = await this.$httpService.put(url, payload);
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loadingItem = false;
      }
    },
    handleBack() {
      if (this.isModal) {
        this.$emit("modal-end-up");
      } else {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/");
      }
    },
    afterSave() {
      if (this.backUrl) {
        this.$route.push(this.backUrl);
      } else {
        this.handleBack();
      }
    },
  },
  created() {
    this.getPermissionGroups();
    // this.fetchData()
  },
};
</script>

<style>
</style>
